module.exports = {
      id: "device-usage",
      viewBox: "0 0 11 18",
      url: __webpack_public_path__ + "assets/img/sprite-6589e8.svg#device-usage",
      toString: function () {
        return this.url;
      }
    }